/**
 * Le contrôle de choix de cette application : un `<select>` NATIF.
 *
 * C'EST UNE DÉCISION, PAS UN RACCOURCI
 * ------------------------------------
 * La plateforme fournit gratuitement ce qu'un composant sur mesure doit réimplémenter :
 * navigation au clavier, saisie au premier caractère, annonce correcte par les lecteurs
 * d'écran, et sélecteur plein écran sur mobile. Il est en outre pilotable directement par
 * `selectOption` de Playwright — quatre fichiers de test en dépendent.
 *
 * CE QUE CE COMPOSANT CORRIGE
 * ---------------------------
 * La même chaîne de classes était recopiée dans QUINZE fichiers. Aucun de ces quarante-quatre
 * `<select>` ne pouvait donc recevoir le style d'erreur sans toucher la chaîne quinze fois —
 * et aucun ne l'a jamais reçu. Ici, `aria-invalid` le déclenche, exactement comme sur
 * `Input` et `Textarea`.
 */
import type { JSX } from 'react'

import { cn } from '@/lib/utils'

export function SelectNatif({ className, ...props }: React.ComponentProps<'select'>): JSX.Element {
  return (
    <select
      data-slot="select-natif"
      className={cn(
        'flex h-11 w-full rounded-lg border border-input bg-card px-3 py-1 text-sm outline-none',
        'focus-visible:border-ring focus-visible:ring-2 focus-visible:ring-ring',
        // Aligné sur `ui/input.tsx` et `ui/textarea.tsx` : un champ invalide se voit de la
        // même façon quel que soit son type de contrôle.
        'aria-invalid:border-destructive aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40',
        'disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
      {...props}
    />
  )
}
